<template>
  <div id="app">
    <nav class="navbar">
      <router-link to="/" class="logo">
        <span class="logo-text">AFRI BAGS</span>
      </router-link>
      <div class="nav-links">
        <router-link to="/">Home</router-link>
        <router-link to="/products">Products</router-link>
        <router-link to="/about">About</router-link>
        <router-link to="/contact">Contact</router-link>
      </div>
    </nav>
    <router-view />
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-section">
          <h3>AFRI BAGS Zimbabwe</h3>
          <p>Premium PP Woven Sacks Manufacturer</p>
        </div>
        <div class="footer-section">
          <h3>Contact</h3>
          <p>22A Greenock Rd, Harare, Zimbabwe</p>
          <p>Phone: +263 77 656 6281</p>
        </div>
        <div class="footer-section">
          <h3>Quick Links</h3>
          <router-link to="/products">Products</router-link>
          <router-link to="/contact">Contact Us</router-link>
        </div>
      </div>
      <div class="footer-bottom">
        <p>
          &copy; {{ new Date().getFullYear() }} AFRI BAGS Zimbabwe. All rights
          reserved.
        </p>
      </div>
    </footer>
  </div>
</template>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  min-height: -webkit-fill-available;
  display: flex;
  flex-direction: column;
}

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 1rem 2rem;
  background: rgba(26, 77, 46, 0.95);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 0.75rem 1rem;
    background: #1a4d2e;
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;

    .logo {
      align-self: center;
      margin-bottom: 0.25rem;
    }

    .nav-links {
      display: flex;
      flex-direction: row;
      justify-content: center;
      gap: 1rem;
      padding: 0.5rem 0;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
    }
  }

  .logo {
    text-decoration: none;
    display: flex;
    align-items: center;

    .logo-text {
      color: #ffd700;
      font-weight: 800;
      font-size: 1.5rem;
      letter-spacing: 1px;
      position: relative;
      transition: transform 0.3s ease;

      @media (max-width: 768px) {
        font-size: 1.25rem;
      }

      &::after {
        content: "";
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 100%;
        height: 2px;
        background: #ffd700;
        transform: scaleX(0);
        transform-origin: right;
        transition: transform 0.3s ease;
      }

      &:hover::after {
        transform: scaleX(1);
        transform-origin: left;
      }
    }
  }

  .nav-links {
    display: flex;
    gap: 2rem;
    align-items: center;

    a {
      color: white;
      text-decoration: none;
      font-weight: 600;
      position: relative;
      transition: color 0.3s ease;

      &::after {
        content: "";
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 100%;
        height: 2px;
        background: #ffd700;
        transform: scaleX(0);
        transform-origin: right;
        transition: transform 0.3s ease;
      }

      &:hover {
        color: #ffd700;
      }

      &:hover::after {
        transform: scaleX(1);
        transform-origin: left;
      }

      &.router-link-active {
        color: #ffd700;

        &::after {
          transform: scaleX(1);
        }
      }
    }
  }
}

.footer {
  background-color: #1a4d2e;
  color: white;
  margin-top: auto;
  padding: 2rem 0;

  .footer-content {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    padding: 0 2rem;
  }

  .footer-section {
    h3 {
      margin-bottom: 1rem;
      color: #ffd700;
    }

    a {
      display: block;
      color: white;
      text-decoration: none;
      margin-bottom: 0.5rem;

      &:hover {
        color: #ffd700;
      }
    }
  }

  .footer-bottom {
    text-align: center;
    margin-top: 2rem;
    padding-top: 1rem;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr !important;
    text-align: center;
  }
}

html,
body {
  height: -webkit-fill-available;
}
</style>
